<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      :title="titleText"
      right
      backdrop
      shadow
      no-header-close
      @change="showActivatorFunc"
      sidebar-class="slider-canvas-parameter"
    >
      <slot name="activator"></slot>
      <slot name="content"></slot>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: 'tr-slider',
  props: {
    titleText: {
      type: String,
      default: function () {
        return '';
      },
    },
    showActivator: {
      type: null,
      default: function () {
        return false;
      },
    },
  },
  methods: {
    showActivatorFunc(e) {
      this.$emit('showActivator', { payload: e });
    },
  },
};
</script>

<style>
#sidebar-right {
  width: 1000px;
  height: 1080px !important;
}
.b-sidebar-backdrop {
  height: 1080px !important;
}
/* .slider-canvas-parameter {
} */
</style>
